import { api } from "../../lib";

export interface Vendor {
  id: string;
  name: string;
  address: string | null;
  email: string | null;
  primaryPhone: string | null;
  secondaryPhone: string | null;
  ihcDailyMinimum: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVendorInput {
  name: string;
  address?: string;
  email?: string;
  primary_phone?: string;
  secondary_phone?: string;
  ihc_daily_minimum?: number;
}

export interface UpdateVendorInput extends Partial<CreateVendorInput> {
  id: string;
}

export interface VendorDailyProgress {
  minimum: number;
  sent: number;
  completed: number;
}

export const vendorsService = {
  getAll: async () => {
    return api.get<Vendor[]>("/admin/vendors");
  },

  getActive: async () => {
    return api.get<Vendor[]>("/admin/vendors", {
      params: { is_active: true },
    });
  },

  getById: async (id: string) => {
    return api.get<Vendor>(`/admin/vendors/${id}`);
  },

  create: async (input: CreateVendorInput) => {
    return api.post<Vendor>("/admin/vendors", input);
  },

  update: async (input: UpdateVendorInput) => {
    const { id, ...updates } = input;
    return api.put<Vendor>(`/admin/vendors/${id}`, updates);
  },

  updateDailyMinimum: async (id: string, minimum: number) => {
    return api.put<Vendor>(`/admin/vendors/${id}/daily-minimum`, {
      ihc_daily_minimum: minimum,
    });
  },

  getDailyProgress: async (
    vendorId: string,
    date: Date = new Date()
  ): Promise<VendorDailyProgress> => {
    return api.get<VendorDailyProgress>(
      `/admin/vendors/${vendorId}/daily-progress`,
      { params: { date: date.toISOString() } }
    );
  },

  toggleActive: async (id: string) => {
    return api.patch<Vendor>(`/admin/vendors/${id}/toggle-active`);
  },
};
